import types from './types';

const actions = {};

actions.defineFromResponseStatus = ({ commit }, responseStatus) => {
  if (responseStatus === 202) {
    commit(types.SET_GLOBAL_RESPONSE_STATUS, 'ACCEPTED');
    return;
  }

  if (responseStatus === 404) {
    commit(types.SET_GLOBAL_RESPONSE_STATUS, 'NOT_FOUND');
    return;
  }

  if (responseStatus === 422) {
    commit(types.SET_GLOBAL_RESPONSE_STATUS, 'UNPROCESSABLE_ENTITY');
    return;
  }

  commit(types.SET_GLOBAL_RESPONSE_STATUS, 'OK');
};

export default actions;



// WEBPACK FOOTER //
// ./src/screens/Status/store/actions.js